$(async function () {
  if($(".guest-help-desk-container").length === 0 && $('.welcome-faq-page-container').length === 0 && $('.psl-guest-help-desk-container').length === 0) return;

  let icons = {
   'fundraiser': 'icons/faq-icons/nf.svg',
   'learn_with_me':  'icons/faq-icons/lwm.svg',
   'explore_lunar_new_year':  'icons/faq-icons/lwm.svg',
   'school_lunch': 'icons/takeout_icon_red.svg',
   'virtual_fundraiser':  'icons/faq-icons/vcf.svg',
   'read_with_me':  'icons/faq-icons/rwm.svg',
   'achievements_awards':  'icons/faq-icons/aw.svg',
   'teacher_appreciation_request':  'icons/faq-icons/taw.svg',
   'referral':  'icons/faq-icons/ref.svg',
 };



  const programFromUrl=getParam('program');
  let preProgram=null;
  let preCategory=null;
  let title=null;
  const params =new URLSearchParams(window.location.search);
  const topic = params.get('title');

  const savedProgram = getCookie('X-PROGRAM')
  if(topic)
  {
    try {
    const response = await fetch(`/faqs/by-topic?topic=${encodeURIComponent(topic)}&program=${programFromUrl}`, {
      method: 'get',
    });
    let r = await response.json()
    preCategory = r.category
    preProgram = r.topic
    title = r.title
    } catch (err) {
    }
  }

  let selectedProgram =  currentUser === "anonymous" ? (getParam('program') || "") : (
   currentUser === "GUEST" ? savedProgram : ""
  );
  const requestData = selectedProgram ? { program: selectedProgram } : {};

  setCookie('X-PROGRAM', '',365 );
 if(typeof xProgram != 'undefined' && xProgram  === 'fundraiser') $('.get-help.program-select >h2').text('Select your Fundraiser Type');
 request({
   url: '/faqs/programs',
   method: 'GET',
   data: requestData,
   callback:function(programs){
     selectedProgram = selectedProgram || 'fundraiser';
     setCookie('X-PROGRAM', savedProgram,365 );
     $.each(programs, function (k, program) {

       let programName =  program.replace('learn_with_me', 'learn with me')
                                 .replace('school_lunch', 'School Lunch')
                                 .replace('virtual_fundraiser', 'virtual community fundraiser')
                                 .replace('read_with_me', 'read with me')
                                 .replace('explore_lunar_new_year', 'Let\'s Explore Lunar New Year')
                                 .replace('achievements_awards', 'Achievement Awards')
                                 .replace('teacher_appreciation_request', 'Teacher Appreciation Week')
                                 .replace("referral", "Community Ambassadors (Referral)")

       if(programName === 'fundraiser')   programName = 'Neighborhood Fundraiser';
       let qBox = $('<a>').attr({ href: 'javascript:;', 'data-program-name':programName }).addClass('q-box large').append(
           $('<p>').text(programName)
       ).append(
           $('<img/>').attr({
             src: icons[program] || icons['default'],
             alt: programName + ' icon',
           })
       ).attr({'data-program':program}).click(function () {

         $('.faq-topics').html('');
         $('.get-help.questions').hide();
         $('.get-help.answers ').hide();
         $('.faq-programs .q-box').removeClass('active');

         $(this).addClass('active');
         loadCategory($(this).data().program);
         setTimeout(function(){
           scrollToCurremtElement($(".row.faq-topics"));
         },300)
       });

         if(program.replace('learn_with_me', 'learn-with-me') == selectedProgram)  $(qBox).addClass('active');
         if(program.replace('school_lunch', 'school-lunch') == selectedProgram)  $(qBox).addClass('active');
         if(program.replace('virtual_fundraiser', 'virtual-fundraiser') == selectedProgram)  $(qBox).addClass('active');
         if(program.replace('read_with_me', 'read-with-me') == selectedProgram)  $(qBox).addClass('active');
         if(program.replace('explore_lunar_new_year', 'explore-lunar-new-year') == selectedProgram)  $(qBox).addClass('active');
         if(program.replace('achievements_awards', 'achievements-awards') == selectedProgram)  $(qBox).addClass('active');
         if(program.replace('teacher_appreciation_request', 'Teacher Appreciation Week') == selectedProgram)  $(qBox).addClass('active');
         if(program.replace("referral", "Community Ambassadors (Referral)") == selectedProgram)  $(qBox).addClass('active');

      if(currentUser === 'GUEST' ||  programs.length > 1){
        $('.get-help.program-select.container >h2').show();
        $('.faq-programs').append(
            $('<div>').addClass('col-md-4 col-sm-6 fac-box-container').append(qBox)
        );
      }
      else{
        $('.faq-programs').append(
            $('<span class="view-all-programs">').text('< View All Programs').click(function () {
              xProgram = '';
              setCookie('X-PROGRAM', xProgram,365 );
              window.history.pushState({}, '', window.location.pathname);
              window.location.reload();
            })
        );
      }

     });

     if(preProgram){
       let programName =  preProgram.replace('learn_with_me', 'learn with me')
         .replace('school_lunch', 'School Lunch')
         .replace('virtual_fundraiser', 'virtual community fundraiser')
         .replace('read_with_me', 'read with me')
         .replace('explore_lunar_new_year', 'Let\'s Explore Lunar New Year')
         .replace('achievements_awards', 'Achievement Awards')
         .replace('teacher_appreciation_request', 'Teacher Appreciation Week')
         .replace("referral", "Community Ambassadors (Referral)")

       if(programName === 'fundraiser')   programName = 'Neighborhood Fundraiser';

       loadCategory(selectedProgram)

     } else {
       loadCategory(selectedProgram)
     }

   }


 });

function loadCategory(program){
  const savedProgram = getCookie('X-PROGRAM');
  setCookie('X-PROGRAM', '',365 );
 request({
   url: '/faqs/'+program+'/categories?group='+(currentUser === 'anonymous'?'anonymous':'guest'),
   method: 'GET',
   callback: function (categories) {
     setCookie('X-PROGRAM', savedProgram,365 );
     $.each(categories, function (k, category) {
       let qBox = $('<a>').attr({ href: 'javascript:;','data-category-name':category}).addClass('q-box large').append(
           $('<p>').text(category)
       ).click(function () {
         $('.faq-topics .q-box').removeClass('active');
         $(this).addClass('active');
         loadQuestions(category,program);
         setTimeout(function(){
           scrollToCurremtElement($(".get-help.questions"));
         },300)
       });

       $('.faq-topics').append(
           $('<div>').addClass('col-md-4 col-sm-6 fac-box-container').append(qBox)
       );
       forceShowContactUs();
     });
     if(preCategory) $(`a[data-category-name="${preCategory}"]`).click();
   }
 });
}


 function loadQuestions(category,program) {
   request({
     url: '/faqs/'+program+'/' +category + '/topics?group='+(currentUser === 'anonymous'?'anonymous':'guest'),
     method: 'GET',
     callback: function (topics) {
       $('.faq-questions').html('');
       $('section.get-help.answers [data-prop="title"]').html('');
       $('section.get-help.answers [data-prop="description"]').html('');
       $('section.get-help.answers').hide();
       $.each(topics, function (k, topic) {
         let qBox = $('<a>').attr({ href: 'javascript:;','data-title':topic.title }).addClass('q-box').append(
           $('<p>').text(topic.title)
         ).click(function () {
           $('.faq-questions .q-box').removeClass('active');
           $(this).addClass('active');
           loadAnswer(topic)
         });

         $('.faq-questions').append(
           $('<div>').addClass('col-md-4 col-sm-6 fac-box-container').append(qBox)
         );
       });

       $('section.get-help.questions').show();
       forceShowContactUs();
       if(title) $(`a[data-title="${title}"]`).click();
     }

   });
 }

 function loadAnswer(topic) {
   $('section.get-help.answers [data-prop="title"]').html(topic.title);
   $('section.get-help.answers [data-prop="description"]').html(topic.description);
   $('section.get-help.answers').show();
   scrollToCurremtElement($(".get-help.answers"))
   forceShowContactUs();
 }

  $(document).on('click', '[data-title]', function () {
    const title = $(this).data('title');

    const url = new URL(window.location.href);
    url.searchParams.set('title', title);
    const program = $('a.active[data-program]').attr('data-program');
    if(program)
    url.searchParams.set('program', program);

    window.history.replaceState({}, '', url.toString());
  });


  function forceShowContactUs() {
   if(getParam('contact-us')== 'visible')     $('section.get-help.answers').show();
 }
 forceShowContactUs();
});